class HomeService {
  constructor ($q, $http, ngAuthSettings) {
    this.ngAuthSettings = ngAuthSettings;
    this.$q = $q;
    this.$http = $http;
  }

  getProductsBySearchText(pageNumber, searchText, third) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + '/items/items/search-items?pageSize=' + 5 + '&pageNumber=' + pageNumber + '&searchText=' + searchText +'&terceroId=' + third,
        cache : true
      }).then((response) => {
        resolve(response.data);
      }, (reason) => {
        reject(reason);
      });
    });
  }
}

HomeService.$inject = ['$q','$http', 'ngAuthSettings'];

export default HomeService;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/home/home.service.js
 **/